import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { QueryParamsModel } from '../../../../core/_base/crud';
import { Form } from '../models';

export enum FormActionTypes {
  ToggleFormPageLoading = '[Form] Toggle Form Page Loading',
  ToggleFormActionLoading = '[Form] Toggle Form Action Loading',
  RequestFormPage = '[Form] Request Form Page',
  LoadFormPage = '[Form] Load Form Page',
  CancelFormPage = '[Form] Cancel Form Page',
  CreateForm = '[Form] Create Form',
  CreateFormOnServer = '[Form] Create Form On Server',
  UpdateForm = '[Form] Update Form',
  UpdateFormOnServer = '[Form] Update Form On Server',
  UpdateFormStatusOnServer = '[Form] Update Form Status On Server',
  ThrowFormError = '[Form] Throw Form Error',
  ClearFormError = '[Form] Clear Form Error',
}

export class ToggleFormPageLoading implements Action {
  readonly type = FormActionTypes.ToggleFormPageLoading;

  constructor(public payload: { pageLoading: boolean }) {}
}

export class ToggleFormActionLoading implements Action {
  readonly type = FormActionTypes.ToggleFormActionLoading;

  constructor(public payload: { actionLoading: boolean }) {}
}

export class RequestFormPage implements Action {
  readonly type = FormActionTypes.RequestFormPage;

  constructor(public payload: { query: QueryParamsModel }) {}
}

export class LoadFormPage implements Action {
  readonly type = FormActionTypes.LoadFormPage;

  constructor(public payload: { forms: Form[]; totalCount: number; query: QueryParamsModel }) {}
}

export class CancelFormPage implements Action {
  readonly type = FormActionTypes.CancelFormPage;
}

export class CreateForm implements Action {
  readonly type = FormActionTypes.CreateForm;

  constructor(public payload: { form: Form }) {}
}

export class CreateFormOnServer implements Action {
  readonly type = FormActionTypes.CreateFormOnServer;

  constructor(public payload: { form: Form; importedFormId?: number }) {}
}

export class UpdateForm implements Action {
  readonly type = FormActionTypes.UpdateForm;

  constructor(public payload: { form: Update<Form> }) {}
}

export class UpdateFormOnServer implements Action {
  readonly type = FormActionTypes.UpdateFormOnServer;

  constructor(public payload: { form: Form }) {}
}

export class UpdateFormStatusOnServer implements Action {
  readonly type = FormActionTypes.UpdateFormStatusOnServer;

  constructor(public payload: { form: Form }) {}
}

export class ThrowFormError implements Action {
  readonly type = FormActionTypes.ThrowFormError;

  constructor(public payload: { error: any }) {}
}

export class ClearFormError implements Action {
  readonly type = FormActionTypes.ClearFormError;
}

export type FormActions =
  | ToggleFormPageLoading
  | ToggleFormActionLoading
  | RequestFormPage
  | LoadFormPage
  | CancelFormPage
  | CreateForm
  | CreateFormOnServer
  | UpdateForm
  | UpdateFormOnServer
  | UpdateFormStatusOnServer
  | ThrowFormError
  | ClearFormError;
